import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HelpComponent {
  baseUrls: any = {};
  headerData: any = {};
  rowData: any = {};
  filterParams: any = {};

  pageTitle = 'Help';
  supportURL = 'http://pwcnetwork.service-now.com/';
  user = '';

  @Input('base-urls')
  set _base_urls(baseUrls: string) {
    try {
      const parsed = typeof baseUrls === 'string' ? safeJsonInput<any>(baseUrls, null, 'help.parse1') : baseUrls;
      if (parsed && Object.keys(parsed).length > 0) {
        this.baseUrls = parsed;
      }
    } catch (e) {
      console.log('Base URLs input not yet stable.');
    }
  }

  @Input('header-data')
  set _header_data(headerData: string) {
    try {
      const parsed = typeof headerData === 'string' ? safeJsonInput<any>(headerData, null, 'help.parse2') : headerData;
      if (parsed && Object.keys(parsed).length > 0) {
        this.headerData = parsed;
        const currentUser = parsed?.userSettingsData?.user ?? {};
        this.user = JSON.stringify({
          sso: currentUser?.sso_id ?? '',
          role: currentUser?.user_type ?? '',
          access: currentUser?.system_access_level ?? '',
        });
      }
    } catch (e) {
      console.log('Header data input not yet stable.');
    }
  }

  @Input('row-data')
  set _row_data(rowData: string) {
    try {
      this.rowData = typeof rowData === 'string' ? safeJsonInput<any>(rowData, null, 'help.parse3') : rowData || {};
    } catch (e) {
      console.log('Row data input not yet stable.');
    }
  }

  @Input('filter-params')
  set _filter_params(filterParams: string) {
    try {
      const parsed = typeof filterParams === 'string' ? safeJsonInput<any>(filterParams, null, 'help.parse4') : filterParams;
      if (parsed && Object.keys(parsed).length > 0) {
        this.filterParams = parsed;
      }
    } catch (e) {
      console.log('Filter params input not yet stable.');
    }
  }
}
